import Api from '../api';

export const getTheLastSalePhase = async () => {
  const response = await Api.get(`/api/controle_crm/get_the_last_sale_phase`);
  return response.data.sale_phase;
};
